'use client'

import * as React from 'react'
import { tw } from 'utils/classnames'

import { useCarouselContext } from './context'

interface ContainerProps extends React.PropsWithChildren {
  children: React.ReactNode
  className?: string
}

export function Container({ children, className }: ContainerProps) {
  const { containerRef } = useCarouselContext()

  return (
    <div
      ref={containerRef}
      className={tw(
        'scroller-menu-y flex w-full snap-x snap-proximity gap-3 overflow-y-scroll scroll-smooth',
        className,
      )}
    >
      {children}
    </div>
  )
}

Container.displayName = 'Carousel.Container'
